import request from '../request.js'

// 保存/修改
const saveUserGroupRole = function (data) {
    return request({
        url: 'sysUserGroupRole/saveOrUpdate',
        method: 'post',
        data
    })
}

export {
    saveUserGroupRole,
}